import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderService } from '../../services/loader/loader.service';
import { finalize } from 'rxjs';
import { SKIP_LOADER } from '@waseel-asp/tpa-waseel-lib-staging';

let activeRequests = 0;

export const LoaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  if (req.context.get(SKIP_LOADER))
    return next(req);

  if (activeRequests === 0)
    loaderService.show();

  activeRequests++;

  return next(req).pipe(
    finalize(() => {
      activeRequests--;
      if (activeRequests === 0)
        loaderService.hide();
    }));
};
